import React from "react";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";

const InventoryChart: React.FC = () => {
  const options: ApexOptions = {
    chart: {
      type: "bar",
      height: 350,
      toolbar: { show: false },
      background: "transparent",
    },
    theme: {
      mode: "dark",
    },
    colors: ["#3B82F6"],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        borderRadius: 4,
        borderRadiusApplication: "end",
        borderRadiusWhenStacked: "last",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: [
        "Aspirin",
        "Ibuprofen",
        "Paracetamol",
        "Amoxicillin",
        "Lipitor",
      ],
      labels: {
        style: {
          colors: "#9CA3AF",
        },
      },
    },
    yaxis: {
      title: {
        text: "Stock Quantity",
        style: {
          color: "#9CA3AF",
        },
      },
      labels: {
        style: {
          colors: "#9CA3AF",
        },
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      theme: "dark",
      y: {
        formatter: (val) => `${val} units`,
      },
    },
  };

  const series = [
    {
      name: "Stock Level",
      data: [450, 320, 500, 280, 600],
    },
  ];

  return (
    <div className="bg-white dark:bg-[#1a1b1c] border border-gray-200 dark:border-gray-700 rounded-lg p-6 mt-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        Medication Inventory Levels
      </h3>
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={350}
      />
    </div>
  );
};

export default InventoryChart; 